import { Icon } from "@iconify/react";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Form } from "react-bootstrap";

function OBCustomRadioButton({
  id,
  name,
  value,
  checked,
  onChange,
  icon,
  text1,
  text2,
  tooltipText,
  disabled = false,
}) {
  const handleClick = (e) => {
    // If the target is not the radio input itself, trigger onChange manually
    if (e.target.tagName !== "INPUT" && !disabled) {
      e.preventDefault();
      onChange({ target: { name, value } });
    }
  };

  return (
    <div
      onClick={handleClick}
      data-tooltip-id={`ob-sup-type-custom-radio-button-tooltip-${id}`}
      className={`d-flex align-items-center ps-3 pe-3  mb-3 gap-1 ob-supplier-radio-item ${
        disabled && "ob-supplier-radio-item-disabled"
      } `}
    >
      <Form.Check
        type="radio"
        id={id}
        disabled={disabled}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={"radio-button"}
      />
      <div
        className={`d-flex align-items-center ob-supplier-radio-item-wrapper`}
      >
        <div className={"ob-supplier-radio-item-icon"}>
          <img src={icon} alt="icon" width={22} height={22} />
        </div>
        <div className={"ob-supplier-radio-item-text-container"}>
          <p className={"m-0 ob-supplier-radio-item-text1"}>{text1}</p>
          <p className={"m-0 ob-supplier-radio-item-text2"}>{text2}</p>
        </div>
      </div>
      {/* <ReactTooltip
        id={`ob-sup-type-custom-radio-button-tooltip-${id}`}
        className="tooltip"
        place="right"
        content={() => <div>{tooltipText}</div>}
      /> */}
    </div>
  );
}

export default OBCustomRadioButton;
